<template>
  <div>
    <Navbar />
    <section>
      <h1>{{ $t('cookiesPolicyPage.cookiesPolicy') }}</h1>
      <div class="cookies-container">
        <div ref="cookieDeclaration"></div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Footer from '../pages-sections/Footer.vue';
import Navbar from '../pages-sections/Navbar.vue';

export default {
  components: { Navbar, Footer },
  mounted() {
    const script = document.createElement('script');
    script.id = 'CookieDeclaration';
    script.src = 'https://consent.cookiebot.com/4fa0f402-4071-4900-a33f-bea6f210e45a/cd.js';
    script.type = 'text/javascript';
    script.async = true;
    this.$refs.cookieDeclaration.appendChild(script);
  },
  beforeDestroy() {
    const el = this.$refs.cookieDeclaration;
    if (el) el.innerHTML = '';
  },
};
</script>

<style lang="scss" scoped>
section {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border: unset;
  border-radius: unset;

  h1 {
    font-weight: bold;
    line-height: 40px;
  }
}
.cookies-container {
  width: 100%;
  max-width: 780px;
  min-height: 600px;
  padding: 0 1rem;
}
</style>
